module.exports = __webpack_public_path__ + "static/media/6-.b6094456.webp";